import Loadable from '../../components/loadable';

const SentBulkMessageRecipients = Loadable({
  loader: () => import('../../pages/messages/sent_bulk_message_recipients'),
  type: 'block',
});

angular.module('gym').value('SentBulkMessageRecipients', SentBulkMessageRecipients);

const SentBulkMessageRecipientsFiltersModal = Loadable({
  loader: () =>
    import(
      '../../pages/messages/sent_bulk_message_recipients/sent_bulk_message_recipients_filters_modal'
    ),
  type: 'modal',
});

angular
  .module('gym')
  .value('SentBulkMessageRecipientsFiltersModal', SentBulkMessageRecipientsFiltersModal);

const BulkMessageActivityDrawer = Loadable({
  loader: () =>
    import('../../pages/messages/sent_bulk_message_recipients/bulk_message_activity_drawer'),
  type: 'drawer',
});

angular.module('gym').value('BulkMessageActivityDrawer', BulkMessageActivityDrawer);

const RenameBulkMessageModal = Loadable({
  loader: () => import('../../pages/messages/sent_bulk_message_recipients/rename_bulk_message'),
  type: 'modal',
});

angular.module('gym').value('RenameBulkMessageModal', RenameBulkMessageModal);
